import { Component, EventEmitter, Input, ViewChild, signal } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  CreateProfessionalDevelopmentRequestCommand,
  LeaCodeDto,
  PersonSearchResultDto,
  ProfessionalDevelopmentClient,
  SearchClient,
} from 'src/shared/services/api.service';
import { catchValidationErrors } from 'src/shared/utilities/validator-utilities';
import { PersonSearchParams } from 'src/shared/vouchers/voucher-person-search.component';

@Component({
  selector: 'cert-pd-send-lea-requests-form',
  standalone: false,
  templateUrl: './pd-send-lea-requests-form.component.html',
  styles: ``,
})
export class PdSendLeaRequestsFormComponent {
  @Input() leaCodes: LeaCodeDto[] = [];
  @Input() leaCodeId!: number;
  @ViewChild('sendLeaRequestForm') form!: NgForm;

  selectedTargetLeaCodeId: number | undefined;
  searchResults = signal<PersonSearchResultDto[]>([]);
  selectedPerson: PersonSearchResultDto | undefined;
  requestDetails = '';
  searching = signal(false);
  submitting = signal(false);

  errorEmitter = new EventEmitter<any>();

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly professionalDevelopmentClient: ProfessionalDevelopmentClient,
    private readonly searchClient: SearchClient,
  ) {}

  onSearch(params: PersonSearchParams) {
    if (!params.firstName && !params.lastName && !params.ein) {
      this.searchResults.set([]);
      return;
    }
    this.searching.set(true);
    this.searchClient.getPersonsFromSimpleSearch(params.lastName, params.firstName, params.ein).subscribe((results) => {
      this.searchResults.set(results ?? []);
      this.searching.set(false);
    });
  }

  onSelectPerson(person: PersonSearchResultDto) {
    this.selectedPerson = person;
  }

  confirm() {
    const command: CreateProfessionalDevelopmentRequestCommand = {
      leaCodeId: this.leaCodeId,
      targetLeaCodeId: this.selectedTargetLeaCodeId!,
      personId: this.selectedPerson!.personId,
      requestDetails: this.requestDetails,
    };

    this.submitting.set(true);
    this.professionalDevelopmentClient
      .createProfessionalDevelopmentRequest(command)
      .pipe(catchValidationErrors(this.form, this.errorEmitter))
      .subscribe({
        next: () => this.activeModal.close(true),
        error: () => this.submitting.set(false),
      });
  }

  cancel() {
    this.activeModal.dismiss();
  }
}
